import { useLanguageStore } from '../store/languageStore';
import { translations } from '../i18n';

export const useTranslation = () => {
  const language = useLanguageStore((state) => state.language);
  
  const t = (key: string, params?: Record<string, string | number>) => {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value !== 'string') {
      return key;
    }
    
    if (params) {
      return value.replace(/\{(\w+)\}/g, (match, param) => {
        return params[param]?.toString() || match;
      });
    }
    
    return value;
  };
  
  return { t, language };
};

